import * as React from "react";
import { StepComponent as StepProps } from "movestic-blocks/components/__generated__/graphql";

export const StepBlock: React.FunctionComponent<StepProps> = ({ stepNumber }) => (
    <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-cherryMist">
        <span className="text-cherryRed text-h3">{stepNumber}</span>
    </div>
);
